/* =========================================================
   AROMA 247 — fragrance notes overlay toggle
   Handles tap-to-open / tap-to-close on touch devices,
   and adds a click-toggle on desktop for a11y/keyboard users.
   ========================================================= */
(function () {
  'use strict';

  function closeAllExcept(exceptCard) {
    document.querySelectorAll('.aroma-card-oil.aroma-notes-open').forEach(function (card) {
      if (card !== exceptCard) {
        card.classList.remove('aroma-notes-open');
        var btn = card.querySelector('.aroma-notes-toggle');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('.aroma-notes-toggle');

    if (toggle) {
      e.preventDefault();
      e.stopPropagation();

      var card = toggle.closest('.aroma-card-oil');
      if (!card) return;

      var isOpen = card.classList.toggle('aroma-notes-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      // Close any other open overlays so only one is visible at a time.
      if (isOpen) closeAllExcept(card);
      return;
    }

    // Tap outside any open overlay closes it.
    var clickedCard = e.target.closest && e.target.closest('.aroma-card-oil.aroma-notes-open');
    if (!clickedCard) closeAllExcept(null);
  }, true);

  // Esc closes overlays for keyboard users.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllExcept(null);
  });
})();



(function(){
  document.addEventListener('click',function(e){
    if(!e.target.closest('[data-cro-chat]'))return;
    document.body.classList.add('cro-chat-open');
    var n=0;
    (function go(){
      var r=window.$respond;
      if(r&&typeof r.do==='function'){r.do('chat:open');return;}
      if(r&&typeof r.open==='function'){r.open();return;}
      if(++n>25){window.open('https://wa.me/97142860960','_blank','noopener');return;}
      setTimeout(go,150);
    })();
  },true);
  var fab=document.querySelector('.cro-fab');
  if(fab){
    setTimeout(function(){
      fab.classList.add('is-hinting');
      setTimeout(function(){fab.classList.remove('is-hinting');},4200);
    },1800);
  }
})();